import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';

/**
 * 管理华为渠道的数据
 */
export default class HuaWeiDataSourceController extends DataSourceController {
  /**
   * 获取投放内容
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: `${name}（${id}）`, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
